import styled from 'styled-components';
const Wrapper = styled.div `
	pointer-events: ${({ $enabled }) => ($enabled ? 'all' : 'none')};
	user-select: ${({ $enabled }) => ($enabled ? 'auto' : 'none')};
`;
export default {
    Wrapper,
};
